import api from './api';

const historiaService = {
  // Obtener todas las historias clínicas con paginación y filtros
  getHistorias: async (params = {}, endpoint = 'historias') => {
    return await api.get(`/${endpoint}`, { params });
  },

  // Obtener historia clínica por ID
  getHistoria: async (id) => {
    return await api.get(`/historias/${id}`);
  },

  // Crear nueva historia clínica
  createHistoria: async (data) => {
    return await api.post('/historias', data);
  },

  // Actualizar historia clínica
  updateHistoria: async (id, data) => {
    return await api.put(`/historias/${id}`, data);
  },


  // Obtener sesiones de una historia clínica
  getSesiones: async (id) => {
    return await api.get(`/historias/${id}/sesiones`);
  },

  // Obtener documentos de una historia clínica
  getDocumentos: async (id) => {
    return await api.get(`/historias/${id}/documentos`);
  },

  // Finalizar historia clínica
  finalizarHistoria: async (id, observaciones = '') => {
    return await api.put(`/historias/${id}/finalizar`, { observaciones });
  },

  // Reabrir historia clínica
  reabrirHistoria: async (id, motivo = '') => {
    return await api.put(`/historias/${id}/reabrir`, { motivo });
  },

  // Obtener historias clínicas por paciente
  getHistoriasPorPaciente: async (pacienteId) => {
    return await api.get(`/historias/paciente/${pacienteId}`);
  },
  
  // Obtener estadísticas de una historia clínica
  getEstadisticas: async (id) => {
    return await api.get(`/historias/${id}/estadisticas`);
  },
  
  // Obtener especialistas para selector
  getEspecialistas: async () => {
    return await api.get('/especialistas');
  },
  
  // Obtener especialidades para selector
  getEspecialidades: async () => {
    return await api.get('/especialidades');
  },
  
  // Exportar historia clínica a PDF
  exportarPDF: async (id) => {
    return await api.get(`/historias/${id}/exportar-pdf`, {
      responseType: 'blob'
    });
  },
  
  // Obtener eventos de timeline de una historia clínica
  getTimelineEvents: async (id) => {
    return await api.get(`/historias/${id}/timeline`);
  },
  
  // Marcar una historia como en pausa
  pausarHistoria: async (id, motivo = '') => {
    return await api.put(`/historias/${id}/pausar`, { motivo });
  },
  
  // Buscar historias clínicas por texto
  buscarHistorias: async (texto, limite = 10) => {
    return await api.get('/historias/buscar', {
      params: { texto, limite }
    });
  },
  
  // Borrar una historia clínica (solo disponible para administradores)
  deleteHistoria: async (id) => {
    return await api.delete(`/historias/${id}`);
  },

  getEtapasByPrograma: async (programaId) => {
  try {
    const response = await api.get(`/etapas-tratamiento/programa/${programaId}`);
    return response.data;
  } catch (error) {
    console.error('Error al obtener etapas del programa:', error);
    throw error;
  }
},

// Obtener citas por historia clínica con sus etapas
getCitasByHistoriaClinica: async (historiaId) => {
  try {
    const response = await api.get(`/citas/historia/${historiaId}`);
    return response.data;
  } catch (error) {
    console.error('Error al obtener citas de la historia clínica:', error);
    throw error;
  }
},

// Obtener la etapa actual de un paciente
getEtapaActual: async (historiaId) => {
  try {
    const response = await api.get(`/historias-clinicas/${historiaId}/etapa-actual`);
    return response.data;
  } catch (error) {
    console.error('Error al obtener etapa actual:', error);
    throw error;
  }
},

// Cambiar etapa del paciente
cambiarEtapa: async (historiaId, etapaId, observaciones = '') => {
  try {
    const response = await api.post(`/historias-clinicas/${historiaId}/cambiar-etapa`, {
      etapaId,
      observaciones
    });
    return response.data;
  } catch (error) {
    console.error('Error al cambiar etapa del paciente:', error);
    throw error;
  }
},

// Obtener historias por especialista asignado
getHistoriasPorEspecialista: async (especialistaId, params = {}) => {
  return await api.get(`/historias/especialista/${especialistaId}`, { params });
},

// Obtener formularios por etapa
getFormulariosPorEtapa: async (etapaId) => {
  return await api.get(`/formularios/etapa/${etapaId}`);
},

};

export default historiaService;